// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OE4Q","buttons":"styles_buttons__XLWSJ"};